import {DesignerVersion} from '@mintdata-wsp/common/state/ui/visualDesigner/DesignState';
import {IMigration} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/DesignMigrationController';
import {Assert} from '@mintdata/mint-kit/impl/util/Assert';

const MIGRATED_VERSION:DesignerVersion = 48;

export const migration_47_48:IMigration = {
    from: MIGRATED_VERSION - 1,
    to: MIGRATED_VERSION,
    migrate: (designState:any) =>
    {
        Assert.yes(designState.designerVersion === MIGRATED_VERSION - 1);

        console.log(`migration ${MIGRATED_VERSION - 1}->${MIGRATED_VERSION} designState`, designState);

        if( designState.surface && designState.surface.pages )
        {
            Object.values(designState.surface.pages).forEach((page:any) =>
            {
                if( page.artboard && page.artboard.allBoxes )
                {
                    Object.values(page.artboard.allBoxes).forEach((boxSnapshot:any) =>
                    {
                        const {component} = boxSnapshot;

                        if( component.name === 'Tabs' )
                        {
                            const {componentDesc} = boxSnapshot;

                            Object.values(componentDesc._properties).forEach((property:any) =>
                            {
                                if( property.name === 'model' )
                                {
                                    property._value = {
                                        ...propertyValue,
                                        normalState: {
                                            ...propertyValue.normalState,
                                            mainAreaAppearance: {
                                                ...propertyValue.normalState.mainAreaAppearance,
                                                background: {...property._value.background},
                                            },
                                            position: {...makePositionFromDirection(property._value.direction)}
                                        },
                                        selectedState: {
                                            ...propertyValue.selectedState,
                                            tabAppearance: {
                                                ...propertyValue.selectedState.tabAppearance,
                                                background: {...property._value.background},
                                            },
                                        },
                                        selectedTabId: {...property._value.selectedTabId},
                                        items: [...property._value.items],
                                    };
                                }
                            });
                        }
                    });
                }
            });
        }

        designState.designerVersion = MIGRATED_VERSION;

        return designState;
    }
};

function makePositionFromDirection(direction:any)
{
    return {
        '__type': 'STRINGENUM',
        selectedValue: direction.selectedValue === 'Horizontal' ? 'top' : 'left',
        'values': [
            'top',
            'left',
            'right',
            'bottom'
        ]
    };
}

const normalState = {
    'tabAppearance': {
        'font': {
            'typeface': {
                '__type': 'STRINGENUM',
                'selectedValue': 'Helvetica Neue',
                'values': [
                    'Arial',
                    'Verdana',
                    'Times New Roman',
                    'Helvetica Neue'
                ]
            },
            'weight': {
                '__type': 'STRINGENUM',
                'selectedValue': 'Regular',
                'values': [
                    'Thin',
                    'Light',
                    'Regular',
                    'Medium',
                    'Bold'
                ]
            },
            'color': {
                'hex': {
                    '__type': 'STRING',
                    'value': '#d1021c'
                },
                'alpha': {
                    '__type': 'NUMBER',
                    'value': 1
                }
            },
            'size': {
                'value': {
                    '__type': 'NUMBER',
                    'value': 16
                },
                'unitsType': {
                    '__type': 'STRINGENUM',
                    'selectedValue': 'px',
                    'values': [
                        'px',
                        '%',
                        'auto'
                    ]
                }
            },
            'lineHeight': {
                'value': {
                    '__type': 'NUMBER',
                    'value': 16
                },
                'unitsType': {
                    '__type': 'STRINGENUM',
                    'selectedValue': 'px',
                    'values': [
                        'px',
                        '%',
                        'auto'
                    ]
                }
            },
            'character': {
                'value': {
                    '__type': 'NUMBER',
                    'value': 0
                },
                'unitsType': {
                    '__type': 'STRINGENUM',
                    'selectedValue': 'px',
                    'values': [
                        'px',
                        '%',
                        'auto'
                    ]
                }
            },
            'fontStyle': {
                '__type': 'BOOLEAN',
                'value': false
            },
            'decorationUnderline': {
                '__type': 'BOOLEAN',
                'value': false
            },
            'decorationCrossed': {
                '__type': 'BOOLEAN',
                'value': false
            }
        },
        'border': {
            'borderColor': {
                'color': {
                    'hex': {
                        '__type': 'STRING',
                        'value': '#979797'
                    },
                    'alpha': {
                        '__type': 'NUMBER',
                        'value': 1
                    }
                },
                'visibility': {
                    '__type': 'BOOLEAN',
                    'value': true
                }
            },
            'borderThickness': {
                'value': {
                    '__type': 'NUMBER',
                    'value': 1
                },
                'unitsType': {
                    '__type': 'STRINGENUM',
                    'selectedValue': 'px',
                    'values': [
                        'px',
                        '%',
                        'auto'
                    ]
                }
            },
            'borderStyle': {
                '__type': 'STRINGENUM',
                'selectedValue': 'solid',
                'values': [
                    'solid',
                    'dashed',
                    'dotted'
                ]
            },
            'borderRadius': {
                'topLeft': {
                    'value': {
                        '__type': 'NUMBER',
                        'value': 4
                    },
                    'unitsType': {
                        '__type': 'STRINGENUM',
                        'selectedValue': 'px',
                        'values': [
                            'px',
                            '%',
                            'auto'
                        ]
                    }
                },
                'topRight': {
                    'value': {
                        '__type': 'NUMBER',
                        'value': 4
                    },
                    'unitsType': {
                        '__type': 'STRINGENUM',
                        'selectedValue': 'px',
                        'values': [
                            'px',
                            '%',
                            'auto'
                        ]
                    }
                },
                'bottomLeft': {
                    'value': {
                        '__type': 'NUMBER',
                        'value': 0
                    },
                    'unitsType': {
                        '__type': 'STRINGENUM',
                        'selectedValue': 'px',
                        'values': [
                            'px',
                            '%',
                            'auto'
                        ]
                    }
                },
                'bottomRight': {
                    'value': {
                        '__type': 'NUMBER',
                        'value': 0
                    },
                    'unitsType': {
                        '__type': 'STRINGENUM',
                        'selectedValue': 'px',
                        'values': [
                            'px',
                            '%',
                            'auto'
                        ]
                    }
                }
            },
            'borderFill': {
                '__type': 'STRINGENUM',
                'selectedValue': 'borderAll',
                'values': [
                    'borderLeft',
                    'borderTop',
                    'borderRight',
                    'borderBottom',
                    'borderAll'
                ]
            }
        },
        'background': {
            'type': {
                '__type': 'STRINGENUM',
                'selectedValue': 'Solid Color',
                'values': [
                    'Solid Color',
                    'Linear Gradient'
                ]
            },
            'solidColor': {
                'color': {
                    'hex': {
                        '__type': 'STRING',
                        'value': '#eaeaea'
                    },
                    'alpha': {
                        '__type': 'NUMBER',
                        'value': 1
                    }
                },
                'visibility': {
                    '__type': 'BOOLEAN',
                    'value': true
                }
            },
            'gradientFromColor': {
                'color': {
                    'hex': {
                        '__type': 'STRING',
                        'value': '#fff'
                    },
                    'alpha': {
                        '__type': 'NUMBER',
                        'value': 1
                    }
                },
                'visibility': {
                    '__type': 'BOOLEAN',
                    'value': true
                }
            },
            'gradientToColor': {
                'color': {
                    'hex': {
                        '__type': 'STRING',
                        'value': '#000'
                    },
                    'alpha': {
                        '__type': 'NUMBER',
                        'value': 1
                    }
                },
                'visibility': {
                    '__type': 'BOOLEAN',
                    'value': true
                }
            },
            'gradientAngle': {
                '__type': 'NUMBER',
                'value': 0
            }
        },
        'padding': {
            'top': {
                'value': {
                    '__type': 'NUMBER',
                    'value': 8
                },
                'unitsType': {
                    '__type': 'STRINGENUM',
                    'selectedValue': 'px',
                    'values': [
                        'px',
                        '%',
                        'auto'
                    ]
                }
            },
            'right': {
                'value': {
                    '__type': 'NUMBER',
                    'value': 8
                },
                'unitsType': {
                    '__type': 'STRINGENUM',
                    'selectedValue': 'px',
                    'values': [
                        'px',
                        '%',
                        'auto'
                    ]
                }
            },
            'bottom': {
                'value': {
                    '__type': 'NUMBER',
                    'value': 8
                },
                'unitsType': {
                    '__type': 'STRINGENUM',
                    'selectedValue': 'px',
                    'values': [
                        'px',
                        '%',
                        'auto'
                    ]
                }
            },
            'left': {
                'value': {
                    '__type': 'NUMBER',
                    'value': 8
                },
                'unitsType': {
                    '__type': 'STRINGENUM',
                    'selectedValue': 'px',
                    'values': [
                        'px',
                        '%',
                        'auto'
                    ]
                }
            }
        }
    },
    'tabSize': {
        'width': {
            'value': {
                '__type': 'NUMBER',
                'value': 0
            },
            'unitsType': {
                '__type': 'STRINGENUM',
                'selectedValue': 'auto',
                'values': [
                    'px',
                    '%',
                    'auto'
                ]
            }
        },
        'minWidth': {
            'value': {
                '__type': 'NUMBER',
                'value': 60
            },
            'unitsType': {
                '__type': 'STRINGENUM',
                'selectedValue': 'px',
                'values': [
                    'px',
                    '%',
                    'auto'
                ]
            }
        },
        'maxWidth': {
            'value': {
                '__type': 'NUMBER',
                'value': 120
            },
            'unitsType': {
                '__type': 'STRINGENUM',
                'selectedValue': 'px',
                'values': [
                    'px',
                    '%',
                    'auto'
                ]
            }
        },
        'height': {
            'value': {
                '__type': 'NUMBER',
                'value': 32
            },
            'unitsType': {
                '__type': 'STRINGENUM',
                'selectedValue': 'px',
                'values': [
                    'px',
                    '%',
                    'auto'
                ]
            }
        },
        'minHeight': {
            'value': {
                '__type': 'NUMBER',
                'value': 24
            },
            'unitsType': {
                '__type': 'STRINGENUM',
                'selectedValue': 'px',
                'values': [
                    'px',
                    '%',
                    'auto'
                ]
            }
        },
        'maxHeight': {
            'value': {
                '__type': 'NUMBER',
                'value': 48
            },
            'unitsType': {
                '__type': 'STRINGENUM',
                'selectedValue': 'px',
                'values': [
                    'px',
                    '%',
                    'auto'
                ]
            }
        }
    },
    'tabSpacing': {
        'value': {
            '__type': 'NUMBER',
            'value': 10
        },
        'unitsType': {
            '__type': 'STRINGENUM',
            'selectedValue': 'px',
            'values': [
                'px',
                '%',
                'auto'
            ]
        }
    },
    'firstTabSpacing': {
        'value': {
            '__type': 'NUMBER',
            'value': 0
        },
        'unitsType': {
            '__type': 'STRINGENUM',
            'selectedValue': 'px',
            'values': [
                'px',
                '%',
                'auto'
            ]
        }
    },
    'position': {
        '__type': 'STRINGENUM',
        'selectedValue': 'top',
        'values': [
            'left',
            'top',
            'bottom',
            'right'
        ]
    },
    'tabsAlignment': {
        '__type': 'STRINGENUM',
        'selectedValue': 'left',
        'values': [
            'left',
            'center',
            'right',
            'top',
            'middle',
            'bottom',
            'stretch'
        ]
    },
    'tabsLine': {
        'color': {
            'color': {
                'hex': {
                    '__type': 'STRING',
                    'value': '#979797'
                },
                'alpha': {
                    '__type': 'NUMBER',
                    'value': 1
                }
            },
            'visibility': {
                '__type': 'BOOLEAN',
                'value': true
            }
        },
        'thickness': {
            'value': {
                '__type': 'NUMBER',
                'value': 1
            },
            'unitsType': {
                '__type': 'STRINGENUM',
                'selectedValue': 'px',
                'values': [
                    'px',
                    '%',
                    'auto'
                ]
            }
        }
    },
    'mainAreaAppearance': {
        'border': {
            'borderColor': {
                'color': {
                    'hex': {
                        '__type': 'STRING',
                        'value': '#979797'
                    },
                    'alpha': {
                        '__type': 'NUMBER',
                        'value': 1
                    }
                },
                'visibility': {
                    '__type': 'BOOLEAN',
                    'value': true
                }
            },
            'borderThickness': {
                'value': {
                    '__type': 'NUMBER',
                    'value': 1
                },
                'unitsType': {
                    '__type': 'STRINGENUM',
                    'selectedValue': 'px',
                    'values': [
                        'px',
                        '%',
                        'auto'
                    ]
                }
            },
            'borderStyle': {
                '__type': 'STRINGENUM',
                'selectedValue': 'dashed',
                'values': [
                    'solid',
                    'dashed',
                    'dotted'
                ]
            },
            'borderRadius': {
                'topLeft': {
                    'value': {
                        '__type': 'NUMBER',
                        'value': 0
                    },
                    'unitsType': {
                        '__type': 'STRINGENUM',
                        'selectedValue': 'px',
                        'values': [
                            'px',
                            '%',
                            'auto'
                        ]
                    }
                },
                'topRight': {
                    'value': {
                        '__type': 'NUMBER',
                        'value': 0
                    },
                    'unitsType': {
                        '__type': 'STRINGENUM',
                        'selectedValue': 'px',
                        'values': [
                            'px',
                            '%',
                            'auto'
                        ]
                    }
                },
                'bottomLeft': {
                    'value': {
                        '__type': 'NUMBER',
                        'value': 0
                    },
                    'unitsType': {
                        '__type': 'STRINGENUM',
                        'selectedValue': 'px',
                        'values': [
                            'px',
                            '%',
                            'auto'
                        ]
                    }
                },
                'bottomRight': {
                    'value': {
                        '__type': 'NUMBER',
                        'value': 0
                    },
                    'unitsType': {
                        '__type': 'STRINGENUM',
                        'selectedValue': 'px',
                        'values': [
                            'px',
                            '%',
                            'auto'
                        ]
                    }
                }
            },
            'borderFill': {
                '__type': 'STRINGENUM',
                'selectedValue': 'borderAll',
                'values': [
                    'borderLeft',
                    'borderTop',
                    'borderRight',
                    'borderBottom',
                    'borderAll'
                ]
            }
        },
        'background': {
            'type': {
                '__type': 'STRINGENUM',
                'selectedValue': 'Solid Color',
                'values': [
                    'Solid Color',
                    'Linear Gradient'
                ]
            },
            'solidColor': {
                'color': {
                    'hex': {
                        '__type': 'STRING',
                        'value': '#d8d8d8'
                    },
                    'alpha': {
                        '__type': 'NUMBER',
                        'value': 1
                    }
                },
                'visibility': {
                    '__type': 'BOOLEAN',
                    'value': true
                }
            },
            'gradientFromColor': {
                'color': {
                    'hex': {
                        '__type': 'STRING',
                        'value': '#fff'
                    },
                    'alpha': {
                        '__type': 'NUMBER',
                        'value': 1
                    }
                },
                'visibility': {
                    '__type': 'BOOLEAN',
                    'value': true
                }
            },
            'gradientToColor': {
                'color': {
                    'hex': {
                        '__type': 'STRING',
                        'value': '#000'
                    },
                    'alpha': {
                        '__type': 'NUMBER',
                        'value': 1
                    }
                },
                'visibility': {
                    '__type': 'BOOLEAN',
                    'value': true
                }
            },
            'gradientAngle': {
                '__type': 'NUMBER',
                'value': 0
            }
        },
        'padding': {
            'top': {
                'value': {
                    '__type': 'NUMBER',
                    'value': 12
                },
                'unitsType': {
                    '__type': 'STRINGENUM',
                    'selectedValue': 'px',
                    'values': [
                        'px',
                        '%',
                        'auto'
                    ]
                }
            },
            'right': {
                'value': {
                    '__type': 'NUMBER',
                    'value': 12
                },
                'unitsType': {
                    '__type': 'STRINGENUM',
                    'selectedValue': 'px',
                    'values': [
                        'px',
                        '%',
                        'auto'
                    ]
                }
            },
            'bottom': {
                'value': {
                    '__type': 'NUMBER',
                    'value': 12
                },
                'unitsType': {
                    '__type': 'STRINGENUM',
                    'selectedValue': 'px',
                    'values': [
                        'px',
                        '%',
                        'auto'
                    ]
                }
            },
            'left': {
                'value': {
                    '__type': 'NUMBER',
                    'value': 12
                },
                'unitsType': {
                    '__type': 'STRINGENUM',
                    'selectedValue': 'px',
                    'values': [
                        'px',
                        '%',
                        'auto'
                    ]
                }
            }
        }
    },
    'overflowX': {
        '__type': 'STRINGENUM',
        'selectedValue': 'Auto',
        'values': [
            'Auto',
            'Hidden',
            'Visible'
        ]
    },
    'overflowY': {
        '__type': 'STRINGENUM',
        'selectedValue': 'Auto',
        'values': [
            'Auto',
            'Hidden',
            'Visible'
        ]
    }
};

const hoverState = {
    'tabAppearance': {
        'font': {
            'typeface': {
                '__type': 'STRINGENUM',
                'selectedValue': 'Helvetica Neue',
                'values': [
                    'Arial',
                    'Verdana',
                    'Times New Roman',
                    'Helvetica Neue'
                ]
            },
            'weight': {
                '__type': 'STRINGENUM',
                'selectedValue': 'Regular',
                'values': [
                    'Thin',
                    'Light',
                    'Regular',
                    'Medium',
                    'Bold'
                ]
            },
            'color': {
                'hex': {
                    '__type': 'STRING',
                    'value': '#d1021c'
                },
                'alpha': {
                    '__type': 'NUMBER',
                    'value': 1
                }
            },
            'size': {
                'value': {
                    '__type': 'NUMBER',
                    'value': 16
                },
                'unitsType': {
                    '__type': 'STRINGENUM',
                    'selectedValue': 'px',
                    'values': [
                        'px',
                        '%',
                        'auto'
                    ]
                }
            },
            'lineHeight': {
                'value': {
                    '__type': 'NUMBER',
                    'value': 16
                },
                'unitsType': {
                    '__type': 'STRINGENUM',
                    'selectedValue': 'px',
                    'values': [
                        'px',
                        '%',
                        'auto'
                    ]
                }
            },
            'character': {
                'value': {
                    '__type': 'NUMBER',
                    'value': 0
                },
                'unitsType': {
                    '__type': 'STRINGENUM',
                    'selectedValue': 'px',
                    'values': [
                        'px',
                        '%',
                        'auto'
                    ]
                }
            },
            'fontStyle': {
                '__type': 'BOOLEAN',
                'value': false
            },
            'decorationUnderline': {
                '__type': 'BOOLEAN',
                'value': false
            },
            'decorationCrossed': {
                '__type': 'BOOLEAN',
                'value': false
            }
        },
        'border': {
            'borderColor': {
                'color': {
                    'hex': {
                        '__type': 'STRING',
                        'value': '#979797'
                    },
                    'alpha': {
                        '__type': 'NUMBER',
                        'value': 1
                    }
                },
                'visibility': {
                    '__type': 'BOOLEAN',
                    'value': true
                }
            },
            'borderThickness': {
                'value': {
                    '__type': 'NUMBER',
                    'value': 1
                },
                'unitsType': {
                    '__type': 'STRINGENUM',
                    'selectedValue': 'px',
                    'values': [
                        'px',
                        '%',
                        'auto'
                    ]
                }
            },
            'borderStyle': {
                '__type': 'STRINGENUM',
                'selectedValue': 'solid',
                'values': [
                    'solid',
                    'dashed',
                    'dotted'
                ]
            },
            'borderRadius': {
                'topLeft': {
                    'value': {
                        '__type': 'NUMBER',
                        'value': 4
                    },
                    'unitsType': {
                        '__type': 'STRINGENUM',
                        'selectedValue': 'px',
                        'values': [
                            'px',
                            '%',
                            'auto'
                        ]
                    }
                },
                'topRight': {
                    'value': {
                        '__type': 'NUMBER',
                        'value': 4
                    },
                    'unitsType': {
                        '__type': 'STRINGENUM',
                        'selectedValue': 'px',
                        'values': [
                            'px',
                            '%',
                            'auto'
                        ]
                    }
                },
                'bottomLeft': {
                    'value': {
                        '__type': 'NUMBER',
                        'value': 0
                    },
                    'unitsType': {
                        '__type': 'STRINGENUM',
                        'selectedValue': 'px',
                        'values': [
                            'px',
                            '%',
                            'auto'
                        ]
                    }
                },
                'bottomRight': {
                    'value': {
                        '__type': 'NUMBER',
                        'value': 0
                    },
                    'unitsType': {
                        '__type': 'STRINGENUM',
                        'selectedValue': 'px',
                        'values': [
                            'px',
                            '%',
                            'auto'
                        ]
                    }
                }
            },
            'borderFill': {
                '__type': 'STRINGENUM',
                'selectedValue': 'borderAll',
                'values': [
                    'borderLeft',
                    'borderTop',
                    'borderRight',
                    'borderBottom',
                    'borderAll'
                ]
            }
        },
        'background': {
            'type': {
                '__type': 'STRINGENUM',
                'selectedValue': 'Solid Color',
                'values': [
                    'Solid Color',
                    'Linear Gradient'
                ]
            },
            'solidColor': {
                'color': {
                    'hex': {
                        '__type': 'STRING',
                        'value': '#eaeaea'
                    },
                    'alpha': {
                        '__type': 'NUMBER',
                        'value': 1
                    }
                },
                'visibility': {
                    '__type': 'BOOLEAN',
                    'value': true
                }
            },
            'gradientFromColor': {
                'color': {
                    'hex': {
                        '__type': 'STRING',
                        'value': '#fff'
                    },
                    'alpha': {
                        '__type': 'NUMBER',
                        'value': 1
                    }
                },
                'visibility': {
                    '__type': 'BOOLEAN',
                    'value': true
                }
            },
            'gradientToColor': {
                'color': {
                    'hex': {
                        '__type': 'STRING',
                        'value': '#000'
                    },
                    'alpha': {
                        '__type': 'NUMBER',
                        'value': 1
                    }
                },
                'visibility': {
                    '__type': 'BOOLEAN',
                    'value': true
                }
            },
            'gradientAngle': {
                '__type': 'NUMBER',
                'value': 0
            }
        },
        'padding': {
            'top': {
                'value': {
                    '__type': 'NUMBER',
                    'value': 8
                },
                'unitsType': {
                    '__type': 'STRINGENUM',
                    'selectedValue': 'px',
                    'values': [
                        'px',
                        '%',
                        'auto'
                    ]
                }
            },
            'right': {
                'value': {
                    '__type': 'NUMBER',
                    'value': 8
                },
                'unitsType': {
                    '__type': 'STRINGENUM',
                    'selectedValue': 'px',
                    'values': [
                        'px',
                        '%',
                        'auto'
                    ]
                }
            },
            'bottom': {
                'value': {
                    '__type': 'NUMBER',
                    'value': 8
                },
                'unitsType': {
                    '__type': 'STRINGENUM',
                    'selectedValue': 'px',
                    'values': [
                        'px',
                        '%',
                        'auto'
                    ]
                }
            },
            'left': {
                'value': {
                    '__type': 'NUMBER',
                    'value': 8
                },
                'unitsType': {
                    '__type': 'STRINGENUM',
                    'selectedValue': 'px',
                    'values': [
                        'px',
                        '%',
                        'auto'
                    ]
                }
            }
        }
    },
    'isEnabled': {
        '__type': 'BOOLEAN',
        'value': false
    }
};

const activeState = {
    'tabAppearance': {
        'font': {
            'typeface': {
                '__type': 'STRINGENUM',
                'selectedValue': 'Helvetica Neue',
                'values': [
                    'Arial',
                    'Verdana',
                    'Times New Roman',
                    'Helvetica Neue'
                ]
            },
            'weight': {
                '__type': 'STRINGENUM',
                'selectedValue': 'Regular',
                'values': [
                    'Thin',
                    'Light',
                    'Regular',
                    'Medium',
                    'Bold'
                ]
            },
            'color': {
                'hex': {
                    '__type': 'STRING',
                    'value': '#d1021c'
                },
                'alpha': {
                    '__type': 'NUMBER',
                    'value': 1
                }
            },
            'size': {
                'value': {
                    '__type': 'NUMBER',
                    'value': 16
                },
                'unitsType': {
                    '__type': 'STRINGENUM',
                    'selectedValue': 'px',
                    'values': [
                        'px',
                        '%',
                        'auto'
                    ]
                }
            },
            'lineHeight': {
                'value': {
                    '__type': 'NUMBER',
                    'value': 16
                },
                'unitsType': {
                    '__type': 'STRINGENUM',
                    'selectedValue': 'px',
                    'values': [
                        'px',
                        '%',
                        'auto'
                    ]
                }
            },
            'character': {
                'value': {
                    '__type': 'NUMBER',
                    'value': 0
                },
                'unitsType': {
                    '__type': 'STRINGENUM',
                    'selectedValue': 'px',
                    'values': [
                        'px',
                        '%',
                        'auto'
                    ]
                }
            },
            'fontStyle': {
                '__type': 'BOOLEAN',
                'value': false
            },
            'decorationUnderline': {
                '__type': 'BOOLEAN',
                'value': false
            },
            'decorationCrossed': {
                '__type': 'BOOLEAN',
                'value': false
            }
        },
        'border': {
            'borderColor': {
                'color': {
                    'hex': {
                        '__type': 'STRING',
                        'value': '#979797'
                    },
                    'alpha': {
                        '__type': 'NUMBER',
                        'value': 1
                    }
                },
                'visibility': {
                    '__type': 'BOOLEAN',
                    'value': true
                }
            },
            'borderThickness': {
                'value': {
                    '__type': 'NUMBER',
                    'value': 1
                },
                'unitsType': {
                    '__type': 'STRINGENUM',
                    'selectedValue': 'px',
                    'values': [
                        'px',
                        '%',
                        'auto'
                    ]
                }
            },
            'borderStyle': {
                '__type': 'STRINGENUM',
                'selectedValue': 'solid',
                'values': [
                    'solid',
                    'dashed',
                    'dotted'
                ]
            },
            'borderRadius': {
                'topLeft': {
                    'value': {
                        '__type': 'NUMBER',
                        'value': 4
                    },
                    'unitsType': {
                        '__type': 'STRINGENUM',
                        'selectedValue': 'px',
                        'values': [
                            'px',
                            '%',
                            'auto'
                        ]
                    }
                },
                'topRight': {
                    'value': {
                        '__type': 'NUMBER',
                        'value': 4
                    },
                    'unitsType': {
                        '__type': 'STRINGENUM',
                        'selectedValue': 'px',
                        'values': [
                            'px',
                            '%',
                            'auto'
                        ]
                    }
                },
                'bottomLeft': {
                    'value': {
                        '__type': 'NUMBER',
                        'value': 0
                    },
                    'unitsType': {
                        '__type': 'STRINGENUM',
                        'selectedValue': 'px',
                        'values': [
                            'px',
                            '%',
                            'auto'
                        ]
                    }
                },
                'bottomRight': {
                    'value': {
                        '__type': 'NUMBER',
                        'value': 0
                    },
                    'unitsType': {
                        '__type': 'STRINGENUM',
                        'selectedValue': 'px',
                        'values': [
                            'px',
                            '%',
                            'auto'
                        ]
                    }
                }
            },
            'borderFill': {
                '__type': 'STRINGENUM',
                'selectedValue': 'borderAll',
                'values': [
                    'borderLeft',
                    'borderTop',
                    'borderRight',
                    'borderBottom',
                    'borderAll'
                ]
            }
        },
        'background': {
            'type': {
                '__type': 'STRINGENUM',
                'selectedValue': 'Solid Color',
                'values': [
                    'Solid Color',
                    'Linear Gradient'
                ]
            },
            'solidColor': {
                'color': {
                    'hex': {
                        '__type': 'STRING',
                        'value': '#eaeaea'
                    },
                    'alpha': {
                        '__type': 'NUMBER',
                        'value': 1
                    }
                },
                'visibility': {
                    '__type': 'BOOLEAN',
                    'value': true
                }
            },
            'gradientFromColor': {
                'color': {
                    'hex': {
                        '__type': 'STRING',
                        'value': '#fff'
                    },
                    'alpha': {
                        '__type': 'NUMBER',
                        'value': 1
                    }
                },
                'visibility': {
                    '__type': 'BOOLEAN',
                    'value': true
                }
            },
            'gradientToColor': {
                'color': {
                    'hex': {
                        '__type': 'STRING',
                        'value': '#000'
                    },
                    'alpha': {
                        '__type': 'NUMBER',
                        'value': 1
                    }
                },
                'visibility': {
                    '__type': 'BOOLEAN',
                    'value': true
                }
            },
            'gradientAngle': {
                '__type': 'NUMBER',
                'value': 0
            }
        },
        'padding': {
            'top': {
                'value': {
                    '__type': 'NUMBER',
                    'value': 8
                },
                'unitsType': {
                    '__type': 'STRINGENUM',
                    'selectedValue': 'px',
                    'values': [
                        'px',
                        '%',
                        'auto'
                    ]
                }
            },
            'right': {
                'value': {
                    '__type': 'NUMBER',
                    'value': 8
                },
                'unitsType': {
                    '__type': 'STRINGENUM',
                    'selectedValue': 'px',
                    'values': [
                        'px',
                        '%',
                        'auto'
                    ]
                }
            },
            'bottom': {
                'value': {
                    '__type': 'NUMBER',
                    'value': 8
                },
                'unitsType': {
                    '__type': 'STRINGENUM',
                    'selectedValue': 'px',
                    'values': [
                        'px',
                        '%',
                        'auto'
                    ]
                }
            },
            'left': {
                'value': {
                    '__type': 'NUMBER',
                    'value': 8
                },
                'unitsType': {
                    '__type': 'STRINGENUM',
                    'selectedValue': 'px',
                    'values': [
                        'px',
                        '%',
                        'auto'
                    ]
                }
            }
        }
    },
    'isEnabled': {
        '__type': 'BOOLEAN',
        'value': false
    }
};

const selectedState = {
    'tabAppearance': {
        'font': {
            'typeface': {
                '__type': 'STRINGENUM',
                'selectedValue': 'Helvetica Neue',
                'values': [
                    'Arial',
                    'Verdana',
                    'Times New Roman',
                    'Helvetica Neue'
                ]
            },
            'weight': {
                '__type': 'STRINGENUM',
                'selectedValue': 'Regular',
                'values': [
                    'Thin',
                    'Light',
                    'Regular',
                    'Medium',
                    'Bold'
                ]
            },
            'color': {
                'hex': {
                    '__type': 'STRING',
                    'value': '#4b4b4b'
                },
                'alpha': {
                    '__type': 'NUMBER',
                    'value': 1
                }
            },
            'size': {
                'value': {
                    '__type': 'NUMBER',
                    'value': 16
                },
                'unitsType': {
                    '__type': 'STRINGENUM',
                    'selectedValue': 'px',
                    'values': [
                        'px',
                        '%',
                        'auto'
                    ]
                }
            },
            'lineHeight': {
                'value': {
                    '__type': 'NUMBER',
                    'value': 16
                },
                'unitsType': {
                    '__type': 'STRINGENUM',
                    'selectedValue': 'px',
                    'values': [
                        'px',
                        '%',
                        'auto'
                    ]
                }
            },
            'character': {
                'value': {
                    '__type': 'NUMBER',
                    'value': 0
                },
                'unitsType': {
                    '__type': 'STRINGENUM',
                    'selectedValue': 'px',
                    'values': [
                        'px',
                        '%',
                        'auto'
                    ]
                }
            },
            'fontStyle': {
                '__type': 'BOOLEAN',
                'value': false
            },
            'decorationUnderline': {
                '__type': 'BOOLEAN',
                'value': false
            },
            'decorationCrossed': {
                '__type': 'BOOLEAN',
                'value': false
            }
        },
        'border': {
            'borderColor': {
                'color': {
                    'hex': {
                        '__type': 'STRING',
                        'value': '#979797'
                    },
                    'alpha': {
                        '__type': 'NUMBER',
                        'value': 1
                    }
                },
                'visibility': {
                    '__type': 'BOOLEAN',
                    'value': true
                }
            },
            'borderThickness': {
                'value': {
                    '__type': 'NUMBER',
                    'value': 1
                },
                'unitsType': {
                    '__type': 'STRINGENUM',
                    'selectedValue': 'px',
                    'values': [
                        'px',
                        '%',
                        'auto'
                    ]
                }
            },
            'borderStyle': {
                '__type': 'STRINGENUM',
                'selectedValue': 'solid',
                'values': [
                    'solid',
                    'dashed',
                    'dotted'
                ]
            },
            'borderRadius': {
                'topLeft': {
                    'value': {
                        '__type': 'NUMBER',
                        'value': 4
                    },
                    'unitsType': {
                        '__type': 'STRINGENUM',
                        'selectedValue': 'px',
                        'values': [
                            'px',
                            '%',
                            'auto'
                        ]
                    }
                },
                'topRight': {
                    'value': {
                        '__type': 'NUMBER',
                        'value': 4
                    },
                    'unitsType': {
                        '__type': 'STRINGENUM',
                        'selectedValue': 'px',
                        'values': [
                            'px',
                            '%',
                            'auto'
                        ]
                    }
                },
                'bottomLeft': {
                    'value': {
                        '__type': 'NUMBER',
                        'value': 0
                    },
                    'unitsType': {
                        '__type': 'STRINGENUM',
                        'selectedValue': 'px',
                        'values': [
                            'px',
                            '%',
                            'auto'
                        ]
                    }
                },
                'bottomRight': {
                    'value': {
                        '__type': 'NUMBER',
                        'value': 0
                    },
                    'unitsType': {
                        '__type': 'STRINGENUM',
                        'selectedValue': 'px',
                        'values': [
                            'px',
                            '%',
                            'auto'
                        ]
                    }
                }
            },
            'borderFill': {
                '__type': 'STRINGENUM',
                'selectedValue': 'borderAll',
                'values': [
                    'borderLeft',
                    'borderTop',
                    'borderRight',
                    'borderBottom',
                    'borderAll'
                ]
            }
        },
        'background': {
            'type': {
                '__type': 'STRINGENUM',
                'selectedValue': 'Solid Color',
                'values': [
                    'Solid Color',
                    'Linear Gradient'
                ]
            },
            'solidColor': {
                'color': {
                    'hex': {
                        '__type': 'STRING',
                        'value': '#d8d8d8'
                    },
                    'alpha': {
                        '__type': 'NUMBER',
                        'value': 1
                    }
                },
                'visibility': {
                    '__type': 'BOOLEAN',
                    'value': true
                }
            },
            'gradientFromColor': {
                'color': {
                    'hex': {
                        '__type': 'STRING',
                        'value': '#fff'
                    },
                    'alpha': {
                        '__type': 'NUMBER',
                        'value': 1
                    }
                },
                'visibility': {
                    '__type': 'BOOLEAN',
                    'value': true
                }
            },
            'gradientToColor': {
                'color': {
                    'hex': {
                        '__type': 'STRING',
                        'value': '#000'
                    },
                    'alpha': {
                        '__type': 'NUMBER',
                        'value': 1
                    }
                },
                'visibility': {
                    '__type': 'BOOLEAN',
                    'value': true
                }
            },
            'gradientAngle': {
                '__type': 'NUMBER',
                'value': 0
            }
        },
        'padding': {
            'top': {
                'value': {
                    '__type': 'NUMBER',
                    'value': 8
                },
                'unitsType': {
                    '__type': 'STRINGENUM',
                    'selectedValue': 'px',
                    'values': [
                        'px',
                        '%',
                        'auto'
                    ]
                }
            },
            'right': {
                'value': {
                    '__type': 'NUMBER',
                    'value': 8
                },
                'unitsType': {
                    '__type': 'STRINGENUM',
                    'selectedValue': 'px',
                    'values': [
                        'px',
                        '%',
                        'auto'
                    ]
                }
            },
            'bottom': {
                'value': {
                    '__type': 'NUMBER',
                    'value': 8
                },
                'unitsType': {
                    '__type': 'STRINGENUM',
                    'selectedValue': 'px',
                    'values': [
                        'px',
                        '%',
                        'auto'
                    ]
                }
            },
            'left': {
                'value': {
                    '__type': 'NUMBER',
                    'value': 8
                },
                'unitsType': {
                    '__type': 'STRINGENUM',
                    'selectedValue': 'px',
                    'values': [
                        'px',
                        '%',
                        'auto'
                    ]
                }
            }
        }
    },
    'isEnabled': {
        '__type': 'BOOLEAN',
        'value': true
    }
};

const propertyValue = {
    'selectedTabId': {
        '__type': 'STRING',
        'value': ''
    },
    'items': [],

    normalState: {...normalState},
    hoverState: {...hoverState},
    activeState: {...activeState},
    selectedState: {...selectedState},
};
